import { downgradeComponent } from '@angular/upgrade/static';

import { downgradedAngularModule } from 'src/ajs-app/app';
import { AccountInformationComponent } from 'src/app/parameters/accounts/edit-account/components/account-information/account-information.component';
import { InMessageEmailCustomizationComponent } from 'src/app/parameters/accounts/edit-account/components/in-message-email-customization/in-message-email-customization.component';
import { KakaotalkEngagementInformationComponent } from 'src/app/parameters/accounts/edit-account/components/kakaotalk-engagement-information/kakaotalk-engagement-information.component';
import { MigrateToWaCloudApiComponent } from 'src/app/parameters/accounts/edit-account/components/migrate-to-wa-cloud-api/migrate-to-wa-cloud-api.component';

downgradedAngularModule
  .directive('angularAccountInformation', downgradeComponent({ component: AccountInformationComponent }))
  .directive('angularInMessageEmailCustomization', downgradeComponent({ component: InMessageEmailCustomizationComponent }))
  .directive('angularKakaotalkEngagementInformation', downgradeComponent({ component: KakaotalkEngagementInformationComponent }))
  .directive('angularMigrateToWaCloudApi', downgradeComponent({ component: MigrateToWaCloudApiComponent }))
  ;

